import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
import { captureFeatureFlagBypassToken } from '@infraestructure/helpers/feature-flags/feature-flag-bypass.helper';
import '@angular/localize/init';

if (environment.production) {
  enableProdMode();
}

// Capture the feature flag bypass token from the URL before bootstrapping the app.
// This must happen before the boot-time IS_PUBLIC flag fetch and before navigation to login,
// so the token is available for the initial feature-flags API request and subsequent navigation.
captureFeatureFlagBypassToken(window.location.search);

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
